import { useState, useEffect } from "react";
import { Subscription } from "rxjs";

import session from "@services/session.service";

export default function useSession(): any {
  const [token, setToken] = useState<string>("");
  const [user, setUser] = useState<any>(null);
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);


  function logout() {
    session.logout();
    setToken("");
    setUser(null);
    setIsLoggedIn(false);
    // navigate("/auth/login");
  }

  useEffect(() => {
    console.log("logout.useEffect");
    const subs: Subscription = session.subscribe((loggedIn: boolean) => {
      if (loggedIn) {
        setToken(session.token);
        setUser(session.user);
        setIsLoggedIn(true);
      } else {
        setToken("");
        setUser(null);
        setIsLoggedIn(false);
      }
    });

    return () => {
      subs.unsubscribe();
    };
  }, []);


  return {
    token,
    user,
    isLoggedIn,
    logout,
  };
}
